import React from 'react';

/**
 * @param {object} props
 * @return {*}
 * @constructor
 */
const PostAuth = ({children}) => (
    <main className="flex-1 relative z-0 overflow-y-auto focus:outline-none">
        {children}
    </main>
);

export default PostAuth;
